define(["require", "exports", "three"], function (require, exports, THREE) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    class Controller {
        constructor() {
            this.moveSpeed = 50;
            this.moveVector = new THREE.Vector3(0, 0, 0);
            window.addEventListener('keydown', this.keydown.bind(this), false);
            window.addEventListener('keyup', this.keyup.bind(this), false);
            window.addEventListener('touchstart', this.touchStart.bind(this), false);
            window.addEventListener('touchend', this.touchEnd.bind(this), false);
            window.addEventListener('touchmove', this.touchStart.bind(this), false);
            this.updateMovementVector();
        }
        keydown(event) {
            if (event.altKey)
                return;
            switch (event.keyCode) {
                case 37: // left
                case 65:
                    this.moveLeft = true;
                    break;
                case 39: // right
                case 68:
                    this.moveRight = true;
                    break;
            }
            this.updateMovementVector();
        }
        ;
        keyup(event) {
            switch (event.keyCode) {
                case 37: // left
                case 65:
                    this.moveLeft = false;
                    break;
                case 39: // right
                case 68:
                    this.moveRight = false;
                    break;
            }
            this.updateMovementVector();
        }
        ;
        touchStart(event) {
            if (event.touches.item(0).pageX > window.innerWidth / 2) {
                this.moveRight = true;
                this.moveLeft = false;
            }
            else {
                this.moveRight = false;
                this.moveLeft = true;
            }
            this.updateMovementVector();
        }
        touchEnd(event) {
            this.moveRight = false;
            this.moveLeft = false;
            this.updateMovementVector();
        }
        updateMovementVector() {
            this.moveVector.x = (this.moveLeft ? -this.moveSpeed : 0) + (this.moveRight ? this.moveSpeed : 0);
        }
    }
    exports.Controller = Controller;
});



//////////////////
// WEBPACK FOOTER
// ./src/Controller.ts
// module id = 3
// module chunks = 0